.image-edit-buttons {
  position: absolute;
  display: flex;
  top: 0;
  right: 0;
  background-color: #b7b7b7;
  cursor: pointer;
}
.image-edit-buttons > div {
  padding: 4px 6px;
}
.image-edit-buttons > div:hover {
  background-color: var(--hover-dark);
}
.image-edit-buttons svg {
  width: 1rem;
  fill: currentColor;
}
.image-container {
  height: 187px;
  width: 363px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.image {
  max-height: 187px;
  max-width: 363px;
  vertical-align: middle;
}
.buttons {
  padding-top: 15px;
  display: flex;
  column-gap: 1em;
  justify-content: end;
}
